// eslint-disable-next-line max-lines
import { CircularProgress, Modal, Paper, Typography, Grid, TextField, MenuItem, FormControlLabel, Switch, Fade, Button } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Alert as MaterialAlert } from '@material-ui/lab';
import { DateTimePicker } from '@material-ui/pickers';
import Alert from 'components/Alert';
import CustomMaskedInput from 'components/MaskedInput/index';
import { theme } from 'components/Theme';
import { functions } from 'helpers';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { createCoupons } from 'store/Orbita/Product/actions';

import type { DispatchProp } from 'react-redux';

interface ICoupon {
  key: string;
  description: string;
  type: 'P' | 'V';
  value: string;
  quantity: string;
  limeted_date: Date;
  hasLimitDate: boolean;
  hasLimitQuantity: boolean;
}

interface IProps extends DispatchProp<any> {
  open: boolean;
  handleClose: any;
  product: any;
  update: any;
  coproducers: any;
  user: any;
}

interface IStates {
  coupon: ICoupon;
  submitting: boolean;
  alert: boolean;
}

class CouponForm extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      coupon: {
        key: '',
        description: '',
        type: 'P',
        value: '0',
        quantity: '0',
        limeted_date: new Date(),
        hasLimitDate: false,
        hasLimitQuantity: false,
      },
      submitting: false,
      alert: false,
    };
  }

  handleChange = (
    name: 'key' | 'description' | 'type' | 'value' | 'never' | 'hasLimitQuantity' | 'hasLimitDate' | 'quantity' | 'limeted_date',
    value: any
  ) => {
    const coupon: ICoupon = this.state.coupon;
    if (name === 'type') {
      coupon['value'] = '0';
    }
    coupon[name] = value;
    if (coupon['type'] === 'P' && Number.parseFloat(functions.clearMoneyMask(coupon['value'])) > 95) {
      this.setState({ alert: true });
    }
    this.setState({ coupon });
  };

  handleSubmit = async () => {
    const couponSubmit = {};
    const { coupon } = this.state;

    if (coupon.key === '') {
      toast.warn('Preencha a chave do cupom');
      return;
    }

    if (coupon.description === '') {
      toast.warn('Preencha a descrição do cupom');
      return;
    }

    if (Number.parseFloat(functions.clearMoneyMask(coupon.value)) <= 0) {
      toast.warn('Preencha o valor do cupom');
      return;
    }

    if (coupon.hasLimitDate) {
      couponSubmit['limeted_date'] = moment(coupon.limeted_date).format('Y-M-D H:m');
    }

    if (coupon.hasLimitQuantity) {
      if (Number.parseFloat(functions.clearMoneyMask(coupon.quantity)) <= 0) {
        toast.warn('Preencha a quantidade do cupom');
        return;
      }
      couponSubmit['quantity'] = Number.parseFloat(coupon.quantity);
    }

    if (coupon.type === 'P' && Number.parseFloat(functions.clearMoneyMask(coupon.value)) === 100) {
      toast.warn('Não é permitido criar um cupom com 100% de desconto');
      return;
    }

    const confirmation = await Alert.show({
      title: 'Atenção',
      message:
        'Verifique se seus afiliados e coprodutores possuem uma comissão maior que o valor do produto com cupom de desconto. Nesses casos a comissão será afetada.',
      confirmation: true,
      buttonOk: 'Criar cupom',
      buttonCancel: 'Cancelar',
    });

    if (!confirmation) {
      return;
    }

    couponSubmit['value'] = Number.parseFloat(functions.clearMoneyMask(coupon.value));
    couponSubmit['description'] = coupon.description;
    couponSubmit['key'] = coupon.key;
    couponSubmit['type'] = coupon.type;

    (async () => {
      try {
        this.setState({ submitting: true });
        await this.props.dispatch(createCoupons(this.props.product, couponSubmit));
        toast.success('Cupom criado com sucesso');
        this.setState({ submitting: false });
        this.props.handleClose();
        this.props.update(null, 0);
      } catch (error) {
        toast.error(error);
        this.setState({ submitting: false });
      }
    })();
  };

  render() {
    const coupon: ICoupon = this.state.coupon;

    const warning = () => {
      const { product, coproducers, user } = this.props;
      let active = false;
      active = product.comission_type === 'V' && product.comission_value > 0;
      if (coproducers && coproducers.active) {
        for (let i = 0; i < coproducers.active.length; i++) {
          if (coproducers.active[i].customer_id !== user.id) {
            active = true;
          }
        }
      }
      if (this.state.alert) {
        return (
          <Fade in={true}>
            <Typography style={{ color: 'red' }} component='p'>
              <small>Atenção! Seus ganhos podem ficar negativados com o desconto configurado.</small>
            </Typography>
          </Fade>
        );
      }
      if (active) {
        return (
          <MaterialAlert severity='warning'>
            Verifique se o desconto do cupom não faz com que o valor do produto fique menor que a comissão paga ao co-produtor ou afiliado.
          </MaterialAlert>
        );
      }
      return null;
    };

    return (
      <MuiThemeProvider theme={theme}>
        <Modal
          open={this.props.open}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClose={this.props.handleClose}
        >
          <Paper
            elevation={10}
            style={{
              maxHeight: '99vh',
              overflow: 'auto',
              borderRadius: 4,
              padding: '1.5rem',
              width: '95vw',
              maxWidth: 620,
            }}
          >
            <Typography variant='h6' style={{ color: '#192542' }}>
              Novo Cupom
            </Typography>
            <div className='m32' />
            <div>Preencha os campos abaixo para configurar seu cupom</div>
            <div className='m32' />
            {warning()}
            <div className='m32' />
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TextField
                  value={coupon.key}
                  onChange={(e: any) => this.handleChange('key', e.target.value)}
                  helperText='Ex.: EDZ0001'
                  label='Código do cupom'
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  value={coupon.description}
                  onChange={(e: any) => this.handleChange('description', e.target.value)}
                  fullWidth
                  helperText='Ex.: Cupom promocional'
                  label='Descrição'
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id='type'
                  label='Tipo'
                  select
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={coupon.type}
                  onChange={(e: any) => this.handleChange('type', e.target.value)}
                >
                  <MenuItem value='P'>Porcentagem</MenuItem>
                  <MenuItem value='V'>Valor</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                {coupon.type === 'P' && (
                  <CustomMaskedInput
                    mask='percent'
                    label='Valor'
                    startAdornment='%'
                    fullWidth
                    disableUnderline={true}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={coupon.value}
                    onChange={(value: any) => this.handleChange('value', value)}
                  />
                )}
                {coupon.type === 'V' && (
                  <CustomMaskedInput
                    mask='money'
                    label='Valor'
                    startAdornment='R$'
                    disableUnderline={true}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={coupon.value}
                    onChange={(value: any) => this.handleChange('value', value)}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  label='Limite de uso (opcional)'
                  control={
                    <Switch
                      color='default'
                      checked={coupon.hasLimitQuantity}
                      onChange={(e: any) => this.handleChange('hasLimitQuantity', e.target.checked)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  label='Data de validade (opcional)'
                  control={
                    <Switch
                      color='default'
                      checked={coupon.hasLimitDate}
                      onChange={(e: any) => this.handleChange('hasLimitDate', e.target.checked)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Fade in={coupon.hasLimitQuantity} timeout={500}>
                  <div>
                    <CustomMaskedInput
                      mask='number'
                      label='Quantidade'
                      fullWidth
                      disableUnderline={true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={coupon.quantity}
                      onChange={(value: any) => this.handleChange('quantity', value)}
                    />
                  </div>
                </Fade>
              </Grid>
              <Grid item xs={12} md={6}>
                <Fade in={coupon.hasLimitDate} timeout={500}>
                  <DateTimePicker
                    id='limeted_date'
                    label='Data'
                    variant='inline'
                    format='dd/MM/yyyy HH:mm'
                    disableToolbar
                    disablePast
                    minDate={new Date()}
                    ampm={false}
                    fullWidth
                    value={coupon.limeted_date}
                    onChange={(value: any) => this.handleChange('limeted_date', value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Fade>
              </Grid>
              <div className='m16' />
              <Grid container justify='flex-end'>
                <Button color='default' disabled={this.state.submitting} onClick={this.props.handleClose}>
                  Fechar
                </Button>
                <Button color='secondary' variant='contained' disabled={this.state.submitting} onClick={this.handleSubmit}>
                  Salvar
                  {this.state.submitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Modal>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    coproducers: state.orbita.Product.coProducers,
    user: state.orbita.User.user,
  };
}

export default connect(mapStateToProps)(CouponForm);
